import { render, staticRenderFns } from "./TrueFalseChoice.vue?vue&type=template&id=5a5bce38&"
import script from "./TrueFalseChoice.vue?vue&type=script&lang=js&"
export * from "./TrueFalseChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports